import React from 'react';
import { useWallet } from '@/contexts/WalletContext';
import ConnectWalletInterface from './ConnectWalletInterface';
import ConnectedWalletView from './ConnectedWalletView';
import Spinner from '@/components/ui/Spinner';
import { WalletErrorBoundary } from '@/components/ErrorBoundaries/WalletErrorBoundary';
import { NetworkStatusIndicator } from '@/components/ui/NetworkStatusIndicator';
import styles from '@/styles/components/wallet/WalletPage.module.css';

const WalletPageContent: React.FC = () => {
  const { state, isLoading } = useWallet();

  // Show loading state during wallet operations
  if (isLoading && state.connectionStatus === 'connecting') {
    return (
      <div className={styles.container}>
        <NetworkStatusIndicator />
        <div className={styles.loadingContainer}>
          <Spinner size="lg" color="primary" />
          <span className={styles.loadingText}>Connecting to wallet...</span>
        </div>
      </div>
    );
  }

  // Show error state with retry option
  if (state.connectionStatus === 'error' && state.error) {
    return (
      <div className={styles.container}>
        <NetworkStatusIndicator />
        <div className={styles.errorContainer}>
          <div className={styles.errorText}>Connection Failed</div>
          <div className={styles.errorDescription}>{state.error}</div>
          <ConnectWalletInterface />
        </div>
      </div>
    );
  }

  // Show connected wallet view when wallet is connected
  if (state.isConnected && state.address) {
    return (
      <div className={styles.container}>
        <NetworkStatusIndicator />
        <ConnectedWalletView />
      </div>
    );
  }

  // Show connect wallet interface when no wallet is connected
  return (
    <div className={styles.container}>
      <NetworkStatusIndicator />
      <ConnectWalletInterface />
    </div>
  );
};

const WalletPage: React.FC = () => {
  return (
    <WalletErrorBoundary>
      <WalletPageContent />
    </WalletErrorBoundary>
  );
};

export default WalletPage;